import React from 'react'
import moment from 'moment'
import classnames from 'classnames/bind'
import * as graph from '@adc/sdk'
import type { Scalars, Maybe, ListingStatusGroup } from '@adc/sdk/types'
import Text from '../../elementals/text'
import { formatters } from '../../../utils'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const formatDate = (date: Scalars['DateTime']) =>
  moment(date).format('MM/DD/YYYY')

interface SaleInfoProps {
  listingStatusGroup: ListingStatusGroup
  soldAmount: Maybe<Scalars['Float']> | undefined
  soldOn: Maybe<Scalars['DateTime']> | undefined
  elmId?: string
}

const SaleInfo = ({
  listingStatusGroup,
  soldAmount,
  soldOn,
  elmId = 'sale_info',
}: SaleInfoProps) => {
  const isSold = listingStatusGroup === graph.enums.ListingStatusGroup.Sold
  return (
    <div data-elm-id={elmId} className={cx('sale-info')}>
      <div data-elm-id={`${elmId}_amount`}>
        <Text size='tiny' color='gray'>
          Sold Price
        </Text>
        <Text size='large' color='grayDark' weight='black' className='u-mb-1'>
          {isSold && soldAmount ? formatters.formatMoney(soldAmount) : 'N/A'}
        </Text>
      </div>
      <div className={cx('sale-date')} data-elm-id={`${elmId}_date`}>
        <Text size='tiny' color='gray'>
          Sold On
        </Text>
        <Text size='large' color='grayDark' weight='black' className='u-mb-1'>
          {isSold && soldOn ? formatDate(soldOn) : 'N/A'}
        </Text>
      </div>
    </div>
  )
}

export default SaleInfo
